module.exports = __webpack_public_path__ + "media/images/folder_open-35ca620a.svg";